/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

const msalClientId = process.env.REACT_APP_MSAL_CLIENT_ID;
const msalAuthority = process.env.REACT_APP_MSAL_AUTHORITY;
const apiScope = process.env.REACT_APP_API_SCOPE;

const redirectURI = () => {
    const domain = window.location.hostname;
    let redirectURI = process.env.REACT_APP_REDIRECT_URI;

    if(domain === "localhost") {
        redirectURI = process.env.REACT_APP_REDIRECT_URI;
    }
    if(domain.includes("ruukki")) {
        redirectURI = process.env.REACT_APP_RUUKKI_REDIRECT_URI;
    }
    if(domain.includes("piristeel")) {
        redirectURI = process.env.REACT_APP_PIRISTEEL_REDIRECT_URI;
    }
    return redirectURI;
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = process.env.REACT_APP_DEBUG_LOGGER === "true" ? {
    auth: {
        clientId: msalClientId,
        authority: msalAuthority,
        redirectUri: redirectURI()
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
} 
: 
{
    auth: {
        clientId: msalClientId,
        authority: msalAuthority,
        redirectUri: redirectURI()
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    //url: "https://api-we-inspection-tool-test-01.azurewebsites.net",
    scopes: [apiScope, "openid", "User.Read", "profile", "email"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com" //e.g. https://graph.microsoft.com/v1.0/me
};